import { useNavigate, useSearchParams } from 'react-router-dom'
import { Player, PlayerReq } from '@/services/types/player'
import SJAvatar from '@/components/SJAvatar'
import SJCard from '@/components/SJCard'
import SJCell from '@/components/SJCell'
import { useEffect, useState } from 'react'
import { useSetState } from 'ahooks'
import { deletePlayer, getPlayerById, updatePlayer } from '@/services/player'
import { Dialog, Toast } from 'antd-mobile'
import SJButton from '@/components/SJButton'
import SJCropper from '@/components/SJCropper'

const PlayerDetail = () => {
  document.title = '棋手详情'
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const playerId = searchParams.get('playerId') || ''

  const [visible, setVisible] = useState(false)
  const [player, setPlayer] = useSetState<Player>({
    playerId: '',
    avatarUrl: '',
    name: '',
    faceId: '',
  })

  useEffect(() => {
    handleGetPlayer()
    // eslint-disable-next-line
  }, [])

  const handleGetPlayer = async () => {
    if (!playerId) {
      Toast.show('没有棋手id')
      return
    }
    const res = (await getPlayerById(playerId)) as unknown as Player
    setPlayer(res)
  }

  const handleDelete = (type: 'quit' | 'remove' = 'remove') => {
    Dialog.confirm({
      content:
        type === 'quit'
          ? '确认退出该群组？'
          : '移出群组后将无法查看该棋手以及对弈历史记录，确认移出吗？',
      onConfirm: async () => {
        await deletePlayer(playerId)
        Toast.show({
          content: type === 'quit' ? '退出成功' : '移出成功',
          position: 'center',
        })
        navigate(-1)
      },
    })
  }

  const changeAvatar = () => {
    console.log('show')
    setVisible(true)
  }
  const onCropperSuccess = async (fileUrl: string) => {
    setVisible(false)
    console.log('onCropperSuccess', fileUrl)
    try {
      const params: PlayerReq = {
        playerId: playerId,
        avatarUrl: fileUrl,
      }
      await updatePlayer(params)
      setPlayer({ avatarUrl: fileUrl })
    } catch (error) {}
  }

  const changeName = () => {
    navigate('/player/name', {
      state: {
        type: 'edit',
        playerId: playerId,
      },
    })
  }
  const changeFace = () => {
    navigate('/player/agreement', {
      state: {
        type: 'edit',
        playerId: playerId,
      },
    })
  }

  return (
    <div className="page player-detail">
      <SJAvatar src={player.avatarUrl || ''} onClick={changeAvatar} showName={false} />
      <div className="main">
        <SJCard>
          <SJCell
            title="昵称"
            detail={player.name || '请输入用户昵称'}
            indicator
            onClick={changeName}
          ></SJCell>
          <SJCell
            title="人脸ID"
            detail={
              player.faceId ? (
                <span className="text-green">已绑定</span>
              ) : (
                <span className="text-red">未绑定</span>
              )
            }
            indicator
            onClick={changeFace}
          ></SJCell>
        </SJCard>
        <div className="btn-fixed flex-jc">
          <SJButton type="primary" size="large" onClick={() => handleDelete('remove')}>
            移出群组
          </SJButton>
        </div>
      </div>
      {visible && (
        <SJCropper
          type="stfile"
          onSuccess={onCropperSuccess}
          onCancel={() => setVisible(false)}
        ></SJCropper>
      )}
    </div>
  )
}

export default PlayerDetail
